import PropTypes from 'prop-types';
import React from 'react';

import { IconChevronDown, IconChevronUp } from '$partials/icons';
import ModuleDispatcher from './module-dispatcher';
import { Collapsible, CollapsibleContent, CollapsibleContextConsumer, CollapsibleHeading } from '$partials/base/collapsible';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleAccordionBlock = ({
    content,
    heading,
    id,
    isSelectedAccordion,
    setIsSelectedAccordion
}) => {
    return (
        <div className='bg-sand relative'>
            <Collapsible
                className='w-full'
                id={id}
                openCallback={(isOpen) => {
                    if(isOpen) {
                        setIsSelectedAccordion(id);
                    }
                }}>
                <CollapsibleContextConsumer>
                    {({ isOpened }) => (
                        <div className={`${isSelectedAccordion ? 'bg-sand' : 'bg-white'} relative overflow-hidden`}>
                            <CollapsibleHeading className='w-12/12 border-b border-b-charcoal'>
                                <div className='layout-container relative md:flex py-40'>
                                    <div className='md:w-1/12' />

                                    <div className='md:w-11/12 flex justify-between items-start'>
                                        {heading && (
                                            <h2 className='w-6/12 md:w-6/11 type-style-2 text-left'>
                                                {heading}
                                            </h2>
                                        )}

                                        <span className='cursor-pointer round-button'>
                                            {isOpened ? <IconChevronUp /> : <IconChevronDown/>}
                                        </span>
                                    </div>
                                </div>
                            </CollapsibleHeading>

                            <CollapsibleContent>
                                {content?.map((module, idx) => {
                                    return (
                                        <React.Fragment key={idx}>
                                            <ModuleDispatcher
                                                index={idx}
                                                isAccordionOrSection={true}
                                                isFirstInAccordion={idx === 0}
                                                {...module} />
                                        </React.Fragment>
                                    );
                                })}
                            </CollapsibleContent>
                        </div>
                    )}
                </CollapsibleContextConsumer>
            </Collapsible>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    content: PropTypes.array,
    heading: PropTypes.string,
    id: PropTypes.string,
    isSelectedAccordion: PropTypes.bool,
    setIsSelectedAccordion: PropTypes.func
};

ModuleAccordionBlock.propTypes = propTypes;

export default ModuleAccordionBlock;
